"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _id, _alias, _isNew, _pinCode, _status, _params, _permissions;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConferencePermission = exports.ConferenceStatus = void 0;
const VoxeetSDK_1 = __importDefault(require("../VoxeetSDK"));
/**
 * The ConferenceStatus model represents the possible conference statuses specific for each conference participant.
 */
var ConferenceStatus;
(function (ConferenceStatus) {
    /**
     * Informs that a new conference is created.
     */
    ConferenceStatus["Created"] = "created";
    /**
     * Informs that the local participant successfully joined a conference.
     */
    ConferenceStatus["Joined"] = "joined";
    /**
     * Informs that a conference is ended.
     */
    ConferenceStatus["Ended"] = "ended";
    /**
     * Informs that the local participant successfully left a conference.
     */
    ConferenceStatus["Left"] = "left";
    /**
     * Informs that the conference is destroyed. This status may be triggered by the following situations:
     * - All conference participants left the conference
     * - The [time to live](doc:js-client-sdk-model-conferenceparameters#ttl) or the conference time limit elapsed
     * - The conference creator used the [Terminate](reference:deleteconference) REST API to terminate an ongoing conference
     */
    ConferenceStatus["Destroyed"] = "destroyed";
    /**
     * Informs that an error occurred during a conference.
     */
    ConferenceStatus["Error"] = "error";
})(ConferenceStatus = exports.ConferenceStatus || (exports.ConferenceStatus = {}));
/**
 * The ConferencePermission model represents the possible permissions a participant may have in a conference.
 */
var ConferencePermission;
(function (ConferencePermission) {
    /**
     * Allows a participant to invite participants to a conference.
     */
    ConferencePermission["Invite"] = "INVITE";
    /**
     * Allows a participant to update other participants' permissions.
     */
    ConferencePermission["UpdatePermissions"] = "UPDATE_PERMISSIONS";
    /**
     * Allows a participant to kick other participants from a conference
     */
    ConferencePermission["Kick"] = "KICK";
    /**
     * Allows a participant to join a conference.
     */
    ConferencePermission["Join"] = "JOIN";
    /**
     * Allows a participant to send an audio stream during a conference.
     */
    ConferencePermission["SendAudio"] = "SEND_AUDIO";
    /**
     * Allows a participant to send a video stream during a conference.
     */
    ConferencePermission["SendVideo"] = "SEND_VIDEO";
    /**
     * Allows a participant to share a screen during a conference.
     */
    ConferencePermission["ShareScreen"] = "SHARE_SCREEN";
    /**
     * Allows a participant to share a video during a conference.
     */
    ConferencePermission["ShareVideo"] = "SHARE_VIDEO";
    /**
     * Allows a participant to share a file during a conference.
     */
    ConferencePermission["ShareFile"] = "SHARE_FILE";
    /**
     * Allows a participant to send a message to other participants during a conference.
     */
    ConferencePermission["SendMessage"] = "SEND_MESSAGE";
    /**
     * Allows a participant to record a conference.
     */
    ConferencePermission["Record"] = "RECORD";
    /**
     * Allows a participant to stream a conference.
     */
    ConferencePermission["Stream"] = "STREAM";
})(ConferencePermission = exports.ConferencePermission || (exports.ConferencePermission = {}));
/**
 * The Conference model allows the application to get information about the conference,
 * such as the conference [ID](#id), [alias](#alias), [PIN code](#pincode), [status](#status), conference [parameters](#params), [participants](#participants), [permissions](#permissions), and information if the conference is [new](#isnew).
 */
class Conference {
    /** @ignore */
    constructor(id) {
        _id.set(this, void 0);
        _alias.set(this, void 0);
        _isNew.set(this, void 0);
        _pinCode.set(this, void 0);
        _status.set(this, void 0);
        _params.set(this, void 0);
        _permissions.set(this, void 0);
        __classPrivateFieldSet(this, _id, id);
        __classPrivateFieldSet(this, _permissions, new Set(Object.values(ConferencePermission)));
    }
    /**
     * Provides the conference ID.
     * @return {string}
     */
    get id() {
        return __classPrivateFieldGet(this, _id);
    }
    /**
     * Provides the conference alias.
     * @return {string}
     */
    get alias() {
        return __classPrivateFieldGet(this, _alias);
    }
    /**
     * The property indicating if the created conference is new.
     * @return {boolean}
     */
    get isNew() {
        return __classPrivateFieldGet(this, _isNew);
    }
    /**
     * Provides the PIN code of the conference.
     * @return {string}
     */
    get pinCode() {
        return __classPrivateFieldGet(this, _pinCode);
    }
    /**
     * Provides the conference status.
     * @return {ConferenceStatus}
     */
    get status() {
        return __classPrivateFieldGet(this, _status);
    }
    /**
     * Setter status
     * @param {ConferenceStatus} value
     */
    set status(value) {
        __classPrivateFieldSet(this, _status, value);
    }
    /**
     * Provides the conference parameters.
     * @return {ConferenceParameters}
     */
    get params() {
        return __classPrivateFieldGet(this, _params);
    }
    /**
     * Setter id
     * @param {string} value
     */
    set id(value) {
        __classPrivateFieldSet(this, _id, value);
    }
    /**
     * Setter alias
     * @param {string} value
     */
    set alias(value) {
        __classPrivateFieldSet(this, _alias, value);
    }
    /**
     * Setter isNew
     * @param {boolean} value
     */
    set isNew(value) {
        __classPrivateFieldSet(this, _isNew, value);
    }
    /**
     * Setter pinCode
     * @param {string} value
     */
    set pinCode(value) {
        __classPrivateFieldSet(this, _pinCode, value);
    }
    /**
     * Setter params
     * @param {ConferenceParameters} value
     */
    set params(value) {
        __classPrivateFieldSet(this, _params, value);
    }
    /**
     * Provides the list of conference participants.
     */
    get participants() {
        return VoxeetSDK_1.default.conference.participants;
    }
    /**
     * Provides a list of the local participant's conference permissions.
     */
    get permissions() {
        return __classPrivateFieldGet(this, _permissions);
    }
    /**
     * Setter permissions
     * @param {Set<ConferencePermission>} value
     * @ignore
     */
    set permissions(value) {
        __classPrivateFieldSet(this, _permissions, value);
    }
    /**
     * @ignore
     * @param data
     */
    static fromCreateData(data) {
        const conference = new Conference(data.conferenceId);
        conference.status = ConferenceStatus.Created;
        conference.alias = data.conferenceAlias;
        conference.pinCode = data.conferencePincode;
        conference.isNew = data.isNew;
        if (data.isProtected) {
            conference.permissions = new Set();
        }
        return conference;
    }
}
exports.default = Conference;
_id = new WeakMap(), _alias = new WeakMap(), _isNew = new WeakMap(), _pinCode = new WeakMap(), _status = new WeakMap(), _params = new WeakMap(), _permissions = new WeakMap();
